import { render } from "./ExecutionTimeWidget.vue?vue&type=template&id=306113d2&scoped=true"
import script from "./ExecutionTimeWidget.vue?vue&type=script&lang=js"
export * from "./ExecutionTimeWidget.vue?vue&type=script&lang=js"

import "./ExecutionTimeWidget.vue?vue&type=style&index=0&id=306113d2&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306113d2"]])

export default __exports__